/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEllipsis4: {
  name: 'ellipsis-4';
  data: string;
} = {
  name: 'ellipsis-4',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM3 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z" fill="currentColor"/></svg>`,
};
